var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Button, Dialog, DialogContent, DialogFooter, DialogHeader, Typography } from '@pocketlaw/tetris';
import { Form, Formik } from 'formik';
import { useUpdateEsigningRecipient } from 'app/domains/esigning/hooks/useUpdateEsigningRecipient';
import { UpdateEsigningRecipientRejectionReason } from 'shared/domains/apollo/generated/types';
import { SubmitButton } from 'shared/domains/forms';
import { EmailField } from './EmailField';
import { getSchema } from './schema';
export function EditRecipientEmailDialog(props) {
    const { recipient, onClose } = props;
    const { name } = recipient;
    const [updateRecipient, { error, loading }] = useUpdateEsigningRecipient();
    const [errorReason, setErrorReason] = useState();
    const schema = getSchema();
    const handleSubmit = (data) => __awaiter(this, void 0, void 0, function* () {
        setErrorReason(undefined);
        return updateRecipient({
            variables: {
                recipientId: recipient.id,
                input: { email: data.email },
            },
            onError: (e) => {
                if (e.type === 'rejection') {
                    setErrorReason(e.reason);
                }
            },
            onSuccess: () => {
                onClose();
            },
        });
    });
    const getErrorMessage = (reason) => {
        switch (reason) {
            case UpdateEsigningRecipientRejectionReason.ActiveSignRequest:
                return '';
            case UpdateEsigningRecipientRejectionReason.AlreadySigned:
                return t({
                    comment: 'Update esigning party error message - Party already signed',
                    message: 'The party has already signed the document.',
                });
            case UpdateEsigningRecipientRejectionReason.NotConnectedToEsigningProvider:
                return t({
                    comment: 'Update esigning party error message - Company not connected to eSigning provider',
                    message: 'Your company is not connected to an eSigning provider.',
                });
            default:
                return t({ comment: 'Update esigning party error message - Generic error', message: 'Something went wrong.' });
        }
    };
    const errorTitle = t({
        comment: 'Edit eSigning party email dialog - error title',
        message: 'Could not update email',
    });
    return (<Formik validationSchema={schema} initialValues={{ email: recipient.email }} onSubmit={handleSubmit}>
      <Dialog as={Form} size="sm" onClose={onClose}>
        <DialogHeader title={t({ comment: 'Edit eSigning party email dialog - title', message: 'Edit email' })}/>
        <DialogContent>
          <Typography>
            <Trans comment="Edit eSigning party email dialog - message">
              Edit the email address for <strong>{name}</strong>. A new link to sign the document will be sent out.
            </Trans>
          </Typography>
          <EmailField />
          {error && <Alert appearance="danger" title={errorTitle} message={getErrorMessage()}/>}
          {errorReason && <Alert appearance="danger" title={errorTitle} message={getErrorMessage(errorReason)}/>}
        </DialogContent>
        <DialogFooter>
          <Button type="button" appearance="secondary" disabled={loading} onClick={onClose}>
            <Trans comment="Edit eSigning party email dialog - cancel button label">Cancel</Trans>
          </Button>
          <SubmitButton>
            <Trans comment="Edit eSigning party email dialog - save button label">Save</Trans>
          </SubmitButton>
        </DialogFooter>
      </Dialog>
    </Formik>);
}
